import { useState } from 'react';

import { useLocation } from '@tanstack/react-router';

import { Header } from '@/components/layout/header';
import { Sidebar } from '@/components/layout/sidebar';

export const MainLayout = ({ children }: React.PropsWithChildren) => {
  const [isVisible, setVisible] = useState(false);
  const location = useLocation();

  const closeMobileSidebarMenu = () => setVisible(false);

  return (
    <div className="relative flex h-screen flex-col bg-background-lighter">
      <Header isVisible={isVisible} onClick={setVisible} />
      <div className="flex h-[calc(100vh-108px)] flex-1 bg-background-lighter p-0 sm:px-2 sm:pt-4 lg:pl-[46px] lg:pt-[41px]">
        <Sidebar closeMobileSidebarMenu={closeMobileSidebarMenu} isVisible={isVisible} />
        <div
          onClick={closeMobileSidebarMenu}
          className={`${isVisible ? 'max-md:absolute max-md:bottom-0 max-md:z-30 max-md:h-[calc(100vh-107px)] max-md:w-full max-md:bg-black max-md:opacity-50' : 'hidden'}`}
        />
        <main
          key={location.pathname}
          className="flex flex-1 flex-col overflow-auto p-0 sm:px-4 lg:pl-[27px] lg:pr-[46px]"
        >
          {children}
        </main>
      </div>
    </div>
  );
};
